var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoutIcon = function SvgLogoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 14.667H3.333a2 2 0 0 1-2-2V3.333a2 2 0 0 1 2-2h1.334a.667.667 0 1 0 0-1.333H3.333A3.337 3.337 0 0 0 0 3.333v9.334A3.337 3.337 0 0 0 3.333 16h1.334a.666.666 0 1 0 0-1.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.359 12.471 3.058-3.057a2.005 2.005 0 0 0 0-2.828l-3.058-3.057a.667.667 0 0 0-.943.942l2.861 2.862H4a.667.667 0 1 0 0 1.334h10.278l-2.862 2.862a.665.665 0 0 0 .21 1.096.666.666 0 0 0 .733-.154Z"
  })));
};
export default SvgLogoutIcon;